module.exports = __webpack_public_path__ + "static/media/1.6582f9c1.jpg";